module.exports = __webpack_public_path__ + "static/n95_mask-7f102149454d073092c9c15e2c4b167d.png";